import { ConfirmationDialog, ConfirmationDialogProps } from '@fortem-monorepo/react-ui'
import { PnlAttributions } from '@fortem-monorepo/web-sdk'

import { useBeginValidatingMutation } from '@/pages/operations/pnl-attributions/mutations'

export interface StartAttributionsDialogProps extends Partial<ConfirmationDialogProps> {
  mutationParams: PnlAttributions.StartAttributionsParams
}

export const StartAttributionsDialog: React.FC<StartAttributionsDialogProps> = ({ mutationParams, ...props }) => {
  const startAttributionsMutation = useBeginValidatingMutation(mutationParams)

  return (
    <ConfirmationDialog
      {...props}
      action={async () => {
        await startAttributionsMutation.mutateAsync(mutationParams)
        props.onClose?.()
      }}
      title={`Start attributions for ${mutationParams.fund_name} on ${mutationParams.value_date}`}
      description={
        "This will begin the attributions for the day. It also means that you won't be able to publish them yourself, and will require someone else to review them for you."
      }
      pending={startAttributionsMutation.isPending}
    />
  )
}
